<template>
  <pt-policy-form ref="form" class="pt-policy-form__withData" :isEdit="isEdit" :id="id" :policy-type="policyType"
  :policyDetail="policyDetail" :loading="loading" @typeChange="typeChange" :isIntegral="isIntegral"></pt-policy-form>
</template>

<script>
import PtPolicyForm from './form'
export default {
  name: 'pt-policy-form__withData',
  components: {
    'pt-policy-form': PtPolicyForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    policyType: {
      type: String,
      default: ''
    },
    isIntegral: Boolean
  },
  data () {
    return {
      policyDetail: {},
      loading: false,
      apiUrl: '', // 获取详情api
      typeName: '', // 不同政策类型对应的汉字
      policy_type: this.policyType,
      submitApiUrl: ''// 提交数据的api
    }
  },
  methods: {
    typeChange (val) {
      this.policy_type = val
    },
    // 获取政策详情
    getPolicyDetail () {
      this.$store.dispatch(this.apiUrl, this.id).then(res => {
        this.policyDetail = res
      })
    },
    submit () {
      this.form.validate().then(formValue => {
        if (this.policy_type === 'afterSales') {
          formValue.detail = formValue.content
          this.$delete(formValue, 'content')
        }
        if (!this.submitApiUrl) {
          this.formApiData()
        }
        this.loading = true
        this.$store.dispatch(this.submitApiUrl, formValue).then(data => {
          // doing something ...
          this.$message.success((this.isEdit ? '编辑' : '新建') + this.typeName + '成功')
          this.loading = false
          history.go(-1)
        }).catch(errorMessage => {
          this.loading = false
          this.$message.error(errorMessage || ((this.isEdit ? '编辑' : '新建') + this.typeName + '失败'))
        })
      })
    },
    // api调用的判断
    formApiData () {
      switch (this.policy_type) {
        case 'afterSales':
          this.apiUrl = this.isIntegral ? 'integralAfterSalesPolicieDetail' : 'afterSalesPolicyDetail'
          this.submitApiUrl = this.isIntegral
            ? (this.isEdit ? 'editIntegralAfterSalesPolicie' : 'createIntegralAfterSalesPolicies')
            : (this.isEdit ? 'editAfterSalesPolicy' : 'creatAfterSalesPolicies')
          this.typeName = '售后政策'
          break
        case 'carriage':
          this.apiUrl = this.isIntegral ? 'getCarriagePoliciesDetail' : 'carriagePoliciesDetail'
          this.submitApiUrl = this.isIntegral ? 'createIntegralCarriagePolicies' : 'creatCarriagePolicies'
          this.typeName = '运费规则'
          break
        case 'privacy':
          this.apiUrl = this.isIntegral ? 'getPrivacyPoliciesDetail' : 'privacyPolicyDetail'
          this.submitApiUrl = this.isIntegral ? 'createIntegralPrivacyPolicies' : 'createPrivacyPolicies'
          this.typeName = '隐私条款'
          break
        default:
          console.log('尚未选择类型')
      }
    }
  },
  created () {
    if (this.isEdit && this.policyType) {
      this.formApiData()
      this.getPolicyDetail()
    }
  }
}
</script>
